import { createContext, useContext } from 'react';

export const BonusEligibleGamesContext = createContext({
  gameIds: [],
  games: [],
  gamesResolved: false,
  hasNext: false,
  loadMore: () => {},
  loadingMore: false,
});

export const useBonusEligibleGamesContext = () => useContext(BonusEligibleGamesContext);
